import './ButtonIcon.scss';
import React, { FC, MouseEventHandler } from 'react';
import Icon from '@/components/extra/Icon/Icon';
import type { IconType } from '@/components/extra/Icon/Icon';
import classNames from 'classnames';

type OnClickEvent = MouseEventHandler<HTMLElement>;
type ButtonIconProps = {
    icon: IconType;
    size?: 'm' | 'l';
    label?: string;
    disabled?: boolean;
    className?: string;
    onClick?: (e?: OnClickEvent) => void;
};

const ButtonIcon: FC<ButtonIconProps> = ({
    icon,
    size = 'm',
    label,
    disabled,
    className,
    onClick = () => {},
    ...props
}) => {
    return (
        <button
            {...props}
            className={classNames('ButtonIcon', className, {
                [`ButtonIcon-${size}`]: size !== 'm',
            })}
            disabled={disabled}
            onClick={() => {
                if (!disabled) {
                    onClick();
                }
            }}
        >
            <Icon icon={icon} />
            {label && <span className="invisible">{label}</span>}
        </button>
    );
};

export default ButtonIcon;
